export default __webpack_public_path__ + "static/media/Sai_Teja_Bhoomraogari_Resume.581ed809.pdf";